export default __webpack_public_path__ + "static/media/esg-91.14093198.jpg";